import { apiInterfaceForJson } from "../common/apiManager";

export const fetchPositions = () => {
    return apiInterfaceForJson("/position/v1/", "GET");
};

export const searchPositions = (query) => {
    return apiInterfaceForJson("/position/v1/search", "POST", query);
};

export const createPosition = (positionData) => {
    return apiInterfaceForJson("/position/v1/", "POST", positionData);
};

export const updatePosition = (positionData) => {
    return apiInterfaceForJson("/position/v1/", "PUT", positionData);
};

export const approvePosition = (approvalData) => {
    return apiInterfaceForJson("/position/v1/approve", "POST", approvalData);
};

export const rejectPosition = (positionId) => {
    return apiInterfaceForJson("/position/v1/reject", "POST", { positionId });
};

export const getPositionHistory = (leadId) => {
    return apiInterfaceForJson(`/position/v1/history/${leadId}`, "GET");
};

export const deletePosition = (positionId) => {
    return apiInterfaceForJson("/position/v1/delete", "POST", { _id: positionId });
};
